import * as React from 'react';

import RedirectIfNotAuthenticated from '../../auth/middleware/RedirectIfNotAuthenticated';
import { AppStack } from '../../common/components/AppStacks';
import { EntitiesDataProvider } from '../../entities/EntitiesDataProvider';
import InactivityDetector from '../../session/components/InactivityDetector';

export default function AppLayout() {
    return (
        <RedirectIfNotAuthenticated>
            <EntitiesDataProvider>
                <InactivityDetector>
                    <AppStack />
                </InactivityDetector>
            </EntitiesDataProvider>
        </RedirectIfNotAuthenticated>
    );
}
